import {
  BEGIN_FETCH_LOGIN_ASSISTANT_CONTENT,
  CLOSE_LA,
  LOGIN_FROM_LA,
  REDIRECT_FROM_LA,
  SHOW_LA
} from 'store/ducks/loginAssistant/types';

export const fetchLoginAssistantContent = () => ({ type: BEGIN_FETCH_LOGIN_ASSISTANT_CONTENT });

export const onCloseLoginAssistantClick = () => ({ type: CLOSE_LA });
export const onLoginFromLoginAssistantClick = redirectPath => ({ type: LOGIN_FROM_LA, redirectPath });
export const onRedirectFromLoginAssistantClick = redirectPath => ({ type: REDIRECT_FROM_LA, redirectPath });
export const onShowLoginAssistant = () => ({ type: SHOW_LA });
